import { useQuery } from '@redwoodjs/web';
import { GetLedgerAccounts } from 'types/graphql';

const GET_LEDGER_ACCOUNTS = gql`
  query GetLedgerAccounts($includeDisabled: Boolean) {
    ledgerAccountDetails(includeDisabled: $includeDisabled) {
      id
      name: accountName
      number: accountNumber
      path: fragmentAccountPath
      isPhysical
      accountType
      parentId
      disabled
    }
  }
`;

export type LedgerAccountDetails = GetLedgerAccounts['ledgerAccountDetails'][0];

export function useLedgerAccounts({ includeDisabled }: { includeDisabled?: boolean } = {}) {
  const { data } = useQuery<GetLedgerAccounts>(GET_LEDGER_ACCOUNTS, {
    fetchPolicy: 'cache-first',
    variables: { includeDisabled },
  });

  return data?.ledgerAccountDetails ?? [];
}
